




































import { defineComponent, computed, watch, reactive, toRefs, onMounted } from '@vue/composition-api';
import operationHoverIcon from './operation-hover-icon.vue';
import { CurrentUserModel } from '@/models/current-user';
import commentModel from '../commentModel';
import { useApolloModel } from 'vue-apollo-model';
import { useBroadcast, useBroadCastStream } from '@/common/utils';
import { LoginSource } from '@/common/const';
import { useLog } from '@/common/log';
export default defineComponent({
    components: {
        operationHoverIcon,
    },
    props: {
        comment: {
            type: Object,
            required: true,
        },
        currentWork: {
            type: Object,
            required: true,
        },
        currentAuthor: {
            type: Object,
            required: true,
        },
        isDark: {
            type: Boolean,
        },
        isCurrent: {
            type: Boolean,
        },
    },
    setup(props, { emit }) {
        const log = useLog();
        const status = computed(() => props.comment.status);
        const replyIcon = '';
        const likeIcon = '';

        const model = useApolloModel(commentModel);
        const user = useApolloModel(CurrentUserModel);

        const state = reactive({
            liked: false,
            likedCount: 0,
            replyed: false,
        });

        watch(() => props.comment, () => {
            state.liked = props.comment.liked;
            state.likedCount = props.comment.likedCount;
        }, {
            immediate: true,
        });

        const statusInfo = computed(() => {
            if (status.value === model.comment.status.sending) {
                return '正在发送评论...';
            }
            if (status.value === model.comment.status.fail) {
                return '评论发送失败，点击';
            }
            if (status.value === model.comment.status.success) {
                return '评论发送成功';
            }
            return '';
        });

        // watch(status, (val: string) => {
        //     if (val === model.comment.status.success) {
        //         setTimeout(() => {
        //             if (props.comment.timestamp && props.comment.content) {
        //                 props.comment.status = model.comment.status.done;
        //             }
        //         }, 3000);
        //     }
        // });
        const broadcast = useBroadcast();
        function checkLogin(source: string) {
            if (!user.userInfo.id) {
                broadcast('login', {
                    // 登录源，供日志上报使用
                    source,
                });
                return false;
            }
            return true;
        }

        function reply() {
            if (!checkLogin(LoginSource.REPLY_COMMENT)) {
                return;
            }
            state.replyed = !state.replyed;
            if (state.replyed) {
                model.replyInputId = props.comment.commentId;
                model.handleReply(
                    props.comment.commentId,
                    props.comment.authorId,
                    props.comment.authorName,
                );
                return;
            }
            model.replyInputId = '';
        }

        function restoreState() {
            state.replyed = false;
        }

        async function retry() {
            if (!checkLogin(LoginSource.COMMENT)) {
                return;
            }
            await model.sendComment(
                {
                    photoId: props.currentWork.id,
                    photoAuthorId: props.currentAuthor.id,
                    content: props.comment.content,
                    replyToCommentId: props.comment.replyToCommentId || '0',
                    expTag: props.currentWork.expTag,
                    replyTo: props.comment.replyTo,
                },
                props.comment.commentId,
            );
            props.comment.status = model.comment.status.sending;
        }
        async function favourComment() {
            if (!checkLogin(LoginSource.COMMENT_LIKE)) {
                return;
            }
            log({
                type: 'CLICK',
                event_name: 'LIKE_COMMENT_BUTTON',
                event_value: {
                    like_type: state.liked ? 'DISLIKE' : 'LIKE',
                },
            });
            await model.likeComment({
                photoId: props.currentWork.id,
                commentId: props.comment.commentId,
                cancel: state.liked ? 1 : 0,
                expTag: props.currentWork.expTag,
            });
            const res = model.likeCommentResult;
            if (res === 1) {
                if (!isNaN(state.likedCount)) {
                    if (state.liked) {
                        state.likedCount--;
                    } else {
                        state.likedCount++;
                    }
                }
                state.liked = !state.liked;
            }
        }

        useBroadCastStream('cancel-reply', (data: {}) => {
            state.replyed = false;
        });

        return {
            model,
            user,
            ...toRefs(state),
            statusInfo,
            replyIcon,
            likeIcon,
            status,
            reply,
            retry,
            favourComment,
            restoreState,
        };
    },
});
